<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="emitCancel">
        <div class="modal-container" ref="myContainer">
          <slot name="header"></slot>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'VModal',
  props: {
    propName: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    emitCancel(event) {
      if (!this.$refs['myContainer'].contains(event.target)) {
        this.$emit('cancel');
      }
    },
  },
};
</script>
